module.exports = "<div class=\"thread master\" (click)=\"open(thread)\"><div class=\"layout-row\"><div class=\"flex text-right\"><div class=\"layout-column secondary\"><span class=\"timestamp\" *ngIf=\"hasMessage\">{{ message.timestamp | fromNow }}</span></div></div></div><div class=\"layout-row\"><i class=\"flex-nogrow icon sm zmdi zmdi-globe\"></i><div class=\"flex content\"><div class=\"title\">{{ thread.region.name }}</div><small *ngIf=\"hasMessage\"> {{ message.name }}:  {{ message.text }}</small></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/region-thread/region-thread.component.pug
// module id = 1057
// module chunks = 0